import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PropertyProvider} from 'src/providers/company/property/property';
import {Snackbar} from '../../../../../../util/snackbar';
import Swal from "sweetalert2";
import {HttpClient} from '@angular/common/http';
import {CustomOAuthService} from "../../../../../../service/custom-oauth-service";

@Component({
  selector: 'app-emissor-wpp-modal',
  templateUrl: './emissor-wpp-modal.component.html',
  styleUrls: ['./emissor-wpp-modal.component.scss']
})
export class EmissorWppModalComponent implements OnInit {

  @Input() public companyId;
  @Input() public cpfCNPJ;
  @Input() public appWhatsMember;

  constructor(public activeModal: NgbActiveModal,
              public modalService: NgbModal,
              public propertyProvider: PropertyProvider,
              public snackBar: Snackbar,
              private http: HttpClient,
              private oauthService: CustomOAuthService) {
  }

  public telefone
  public enviando: boolean = false;
  public panelExpanded: boolean = true;

  ngOnInit() {
    this.telefone = '';
    if (this.appWhatsMember && this.appWhatsMember.phoneNumber) {
      this.telefone = this.appWhatsMember.phoneNumber;
    }
  }

  submitTelefone() {
    this.enviando = true;
    const claims = this.oauthService.getIdentityClaims();
    const payload = {
      companyId: this.companyId,
      officeName: claims.details.office.name,
      cpfCnpj: this.cpfCNPJ,
      phoneNumber: this.normalizeWhatsappNumber(this.telefone)
    };
    this.propertyProvider.sendAppWhatsNumber(payload)
      .then(r => {
        return this.http.post('https://n8n.zecadascontas.com.br/webhook/cadastrar-produtor', payload).toPromise();
      })
      .then(r => {
        this.enviando = false;
        Swal.fire({
          title: 'Sucesso',
          text: 'O emissor foi habilitado para o produtor e será enviada uma mensagem de orientações.',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            this.activeModal.close('sucesso');
          }
        });
      })
      .catch(r => {
        this.enviando = false;
        this.snackBar.openLong(r.status.toString() + " " + r.error.error_description, 'erro');
      });
  }

  normalizeWhatsappNumber(number: string): string {
    if (!number) return '';
    const digitsOnly = number.replace(/\D/g, '');
    return digitsOnly;
  }
}
